import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../Redux/Store";
import { allPut } from "../Redux/Actions.tsx";
import { urlutenti } from "../lib/api.ts";
import { useAlert } from "./Alert.tsx";
import { Profile } from "../lib/interface";
import "./PersonalProfile.css";
import ChangePassword from "./ChangePassword.tsx";
import { logout } from "../Redux/Reducers/LoginReducer.ts";
import { useNavigate } from "react-router-dom";
const tipoUtenteOptions = [
  { label: "Account", value: "ACCOUNT" },
  { label: "Associato", value: "ASSOCIATO" },
];

const ruoloOptions = [
  { label: "Admin", value: "ADMIN" },
  { label: "User", value: "USER" },
];

const PersonalProfile: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const { token, profilo } = useSelector((state: RootState) => state.login);
  const navigate = useNavigate();
  const [utente, setUtente] = useState<Profile>(profilo);
  const [isEditing, setIsEditing] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const showAlert = useAlert();

  const handleLogout = () => {
    navigate("/");
    setTimeout(() => {
      dispatch(logout());
    }, 1000);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setUtente((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDropdownChange = (e: { value: string }, name: string) => {
    setUtente((prev) => {
      const updatedUtente = {
        ...prev,
        [name]: e.value,
      };

      if (name === "tipoUtente" && e.value === "ASSOCIATO") {
        updatedUtente.ruolo = "USER";
      }

      return updatedUtente;
    });
  };

  const handleSave = () => {
    const updatedProfile = {
      email: utente.email,
      nome: utente.nome,
      cognome: utente.cognome,
      ruolo: utente.ruolo,
      tipoUtente: utente.tipoUtente,
    };

    dispatch(allPut(`${urlutenti}/${utente.id}`, token, updatedProfile, showAlert)).then((updatedUtente) => {
      if (updatedUtente) {
        showAlert("success", "Salvato", "Profilo aggiornato con successo.", "bottom-end", 3000);
        setIsEditing(false);
        handleLogout();
      } else {
        console.error("Aggiornamento del profilo fallito");
      }
    });
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleCancel = () => {
    setUtente(profilo);
    setIsEditing(false);
  };

  return (
    <Container className="personal-profile">
      <div className="d-flex justify-content-between">
        <h5>Il tuo profilo</h5>
      </div>
      <Row>
        <Col xs={6}>
          <Form.Group className="mb-3">
            <Form.Label>Nome</Form.Label>
            <InputText
              name="nome"
              value={utente.nome}
              onChange={handleChange}
              style={{ width: "100%" }}
              disabled={!isEditing}
              className="input-edit-profile"
            />
          </Form.Group>
        </Col>
        <Col xs={6}>
          <Form.Group className="mb-3">
            <Form.Label>Cognome</Form.Label>
            <InputText
              name="cognome"
              value={utente.cognome}
              onChange={handleChange}
              style={{ width: "100%" }}
              disabled={!isEditing}
              className="input-edit-profile"
            />
          </Form.Group>
        </Col>
        <Col xs={6}>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <InputText
              name="email"
              value={utente.email}
              onChange={handleChange}
              style={{ width: "100%" }}
              disabled={!isEditing}
              className="input-edit-profile"
            />
          </Form.Group>
        </Col>
        {profilo.ruolo === "ADMIN" && (
          <>
            <Col xs={6}>
              <Form.Group className="mb-3">
                <Form.Label>Tipo Utente</Form.Label>
                <Dropdown
                  value={utente.tipoUtente}
                  options={tipoUtenteOptions}
                  onChange={(e) => handleDropdownChange(e, "tipoUtente")}
                  placeholder="Seleziona Tipo Utente"
                  style={{ width: "100%" }}
                  disabled={!isEditing}
                  className="input-edit-profile"
                />
              </Form.Group>
            </Col>
            <Col xs={6}>
              <Form.Group className="mb-3">
                <Form.Label>Ruolo</Form.Label>
                <Dropdown
                  value={utente.ruolo}
                  options={ruoloOptions}
                  onChange={(e) => handleDropdownChange(e, "ruolo")}
                  placeholder="Seleziona Ruolo"
                  style={{ width: "100%" }}
                  className="input-edit-profile"
                  disabled={utente.tipoUtente === "ASSOCIATO" || !isEditing}
                />
              </Form.Group>
            </Col>
          </>
        )}
        <Col xs={6} className="d-flex align-items-center justify-content-end">
          <div className="d-flex justify-content-end">
            {isEditing ? (
              <>
                <Button className="button me-2" onClick={handleSave}>
                  Salva
                </Button>
                <Button variant="secondary" className="button-annulla" onClick={handleCancel}>
                  Annulla
                </Button>
              </>
            ) : (
              <>
                {profilo.tipoUtente === "ACCOUNT" && (
                  <Button className="button-annulla me-2" onClick={() => setShowChangePassword(true)}>
                    Cambia password
                  </Button>
                )}
                <Button className="button" onClick={handleEdit}>
                  Modifica
                </Button>
              </>
            )}
          </div>
        </Col>
      </Row>
      <ChangePassword visible={showChangePassword} onHide={() => setShowChangePassword(false)} />
    </Container>
  );
};

export default PersonalProfile;
